// extracted by mini-css-extract-plugin
export var address = "index-module--address--mQK4M";
export var background_img_curve = "index-module--background_img_curve--qBHPF";
export var company_info = "index-module--company_info--BbgQ-";
export var complaints = "index-module--complaints--4aY7I";
export var contact = "index-module--contact--3LVZH";
export var contact_info = "index-module--contact_info--hg3kg";
export var copyrights = "index-module--copyrights--0Zv0d";
export var divider = "index-module--divider--wb4L1";
export var footer_container = "index-module--footer_container--D1ekL";
export var footer_content_container = "index-module--footer_content_container--z2om2";
export var form_row = "index-module--form_row--9Ley9";
export var info_links = "index-module--info_links--7QOcx";
export var quick_links = "index-module--quick_links--HNkes";
export var socials = "index-module--socials--HzKef";
export var subscribe = "index-module--subscribe--YS8Rv";
export var subscribe_form = "index-module--subscribe_form--XFUj5";
export var subscribe_info = "index-module--subscribe_info--GCG8G";
export var thank_you_message = "index-module--thank_you_message--WozVH";
export var thick_line = "index-module--thick_line--GPLR7";
export var thin_line = "index-module--thin_line--mFqy5";